/* i18n : traductions injectees par layout/theme.liquid (window.PP_I18N) */
function PP_T(k, d) { return (window.PP_I18N && window.PP_I18N[k]) || d; }
/* PERMATAN Parapharmacie — JS du thème.
   - Menu burger mobile du header ([data-pp-burger] / [data-pp-mnav])
   - Section achat pp-formats ([data-ppf]) : sélection de pack, ajout panier
     via window.PMT (permatan.js), barre sticky (mobile : toujours visible ;
     desktop : après le hero, hors section achat et footer).
   - Fallback reveal pour les navigateurs sans animation-timeline: view(). */
(function () {
  'use strict';

  /* ---------- Menu mobile ---------- */
  function initBurger() {
    var btn = document.querySelector('[data-pp-burger]');
    var nav = document.querySelector('[data-pp-mnav]');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      var open = nav.hasAttribute('hidden');
      if (open) nav.removeAttribute('hidden'); else nav.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.querySelectorAll('[data-pp-mnav-link]').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- Section achat ---------- */
  function initFormats() {
    var root = document.querySelector('[data-ppf]');
    if (!root) return;
    var dataEl = root.querySelector('[data-ppf-data]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var stage = root.querySelector('[data-ppf-stage]');
    var mlEl = root.querySelector('[data-ppf-ml]');
    var descEl = root.querySelector('[data-ppf-desc]');
    var saveWrap = root.querySelector('[data-ppf-save]');
    var saveText = root.querySelector('[data-ppf-save-text]');
    var shipEl = root.querySelector('[data-ppf-ship]');
    var atcBtn = root.querySelector('[data-ppf-atc]');
    var atcPrice = root.querySelector('[data-ppf-atc-price]');
    var atcLabel = root.querySelector('[data-ppf-atc-label]');
    var opts = root.querySelectorAll('[data-ppf-opt]');
    var stickyName = document.querySelector('[data-ppf-sticky-name]');
    var stickyPrice = document.querySelector('[data-ppf-sticky-price]');

    var current = null;
    if (opts.length === 0) {
      /* Mode pro (aucun sélecteur B2C rendu) : afficher le flacon à l'unité, pas le Pack 4 */
      for (var i = 0; i < variants.length; i++) {
        if (!(variants[i].sku ? /PACK|KIT/i.test(variants[i].sku) : /Pack|Kit/i.test(variants[i].name))) { current = variants[i]; break; }
      }
    } else {
      for (var i = 0; i < variants.length; i++) {
        if ((variants[i].sku ? /PACK2/i.test(variants[i].sku) : /Pack ?(de |of )?2/i.test(variants[i].name)) && variants[i].available) current = variants[i];
      }
    }
    if (!current) current = variants[0];

    function apply(v) {
      current = v;
      if (stage && v.img) stage.src = v.img;
      if (mlEl) mlEl.textContent = v.ml || '';
      if (descEl) descEl.textContent = v.desc || '';
      if (saveWrap && saveText) {
        if (v.save_f) {
          saveText.textContent = PP_T('you_save', "Vous économisez") + ' ' + v.save_f + ' ' + PP_T('vs_unit', "par rapport au flacon à l’unité");
          saveWrap.style.display = 'flex';
        } else {
          saveWrap.style.display = 'none';
        }
      }
      if (shipEl) shipEl.textContent = PP_T('ship_fast', "Expédition rapide, en colis neutre et discret");
      if (atcPrice) atcPrice.textContent = v.price_f || '';
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        if (atcLabel && !v.available) atcLabel.textContent = 'Rupture de stock';
      }
      if (stickyName) stickyName.textContent = v.name || '';
      if (stickyPrice) stickyPrice.textContent = v.price_f || '';
      opts.forEach(function (opt) {
        var on = opt.getAttribute('data-vid') === String(v.id);
        opt.setAttribute('aria-checked', on ? 'true' : 'false');
        var dot = opt.querySelector('[data-ppf-dot]');
        var ring = opt.querySelector('[data-ppf-ring]');
        if (dot) dot.style.display = on ? '' : 'none';
        if (ring) ring.style.display = on ? '' : 'none';
      });
    }

    opts.forEach(function (opt) {
      function select() {
        var vid = opt.getAttribute('data-vid');
        var v = variants.filter(function (x) { return String(x.id) === vid; })[0];
        if (v) apply(v);
      }
      opt.addEventListener('click', select);
      opt.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(); }
      });
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (!current || !current.available) return;
        if (window.PMT && window.PMT.addToCart) {
          window.PMT.addToCart(current.id, current.name, atcBtn);
        } else {
          window.location.href = '/cart/add?id=' + current.id + '&quantity=1&return_to=/cart';
        }
      });
    }

    /* Barre sticky : renvoie au sélecteur (ancre du markup).
       Mobile (<820px) : TOUJOURS visible. Desktop : après le hero,
       masquée quand la section achat est à l'écran ou près du footer. */
    var sticky = document.querySelector('[data-ppf-sticky]');
    var section = root.closest('section');
    if (sticky && section) {
      sticky.setAttribute('data-ppf-ready', '');
      var onScroll = function () {
        if (window.innerWidth < 820) { sticky.removeAttribute('hidden'); return; }
        var hero = document.getElementById('hero2');
        var heroPast = hero ? hero.getBoundingClientRect().bottom < 0 : (window.scrollY || 0) > 500;
        var rect = section.getBoundingClientRect();
        var formatsOnScreen = rect.top < window.innerHeight && rect.bottom > 0;
        var footer = document.getElementById('footer2') || document.querySelector('footer');
        var nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        if (heroPast && !formatsOnScreen && !nearFooter) sticky.removeAttribute('hidden'); else sticky.setAttribute('hidden', '');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    apply(current);
  }

  /* ---------- Fallback reveal (pas d'animation-timeline: view()) ---------- */
  function initReveals() {
    if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;
    var els = document.querySelectorAll('[style*="view()"]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.style.opacity = '1';
          en.target.style.transform = 'none';
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    var count = 0;
    els.forEach(function (el) {
      el.style.animation = 'none';
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px) scale(.985)';
      el.style.transition = 'opacity .65s cubic-bezier(.22,.61,.36,1) ' + ((count % 4) * 90) + 'ms, transform .65s cubic-bezier(.22,.61,.36,1) ' + ((count % 4) * 90) + 'ms';
      count++;
      io.observe(el);
    });
  }

  function init() {
    initBurger();
    initFormats();
    initReveals();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();